import ResidentAdmissionTemplate from "app/features/residents/templates/view/ResidentAdmissionTemplate";

export default function AdmissionScreen() {
  return <ResidentAdmissionTemplate />;
}
